import React, { useState } from 'react';

import Image from 'Components/Globals/Elements/Image';
import GeneralErrorImage from 'Assets/images/error/cat_update.svg';
import Button from 'Components/Globals/Elements/Button';
import { onCallToSupportTeam } from 'Helpers';

import styles from './styles.module.scss';

const LOGIN_URL = '/pwa/login';

const resetEverything = async () => {
	try {
		if ('serviceWorker' in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();
			await Promise.allSettled(
				registrations.map((registration) => registration.unregister())
			);
		}
	} catch (err) {
		console.error('Failed to unregister service workers:', err);
	}

	try {
		if (typeof caches !== 'undefined') {
			const names = await caches.keys();
			await Promise.allSettled(names.map((name) => caches.delete(name)));
		}
	} catch (err) {
		console.error('Failed to clear caches:', err);
	}

	try {
		localStorage.clear();
		sessionStorage.clear();
	} catch (err) {
		console.error('Failed to clear storage:', err);
	}
};

const ErrorPage = () => {
	const [isResetting, setIsResetting] = useState(false);

	const onNavigateToLogin = async () => {
		if (isResetting) return;
		setIsResetting(true);

		await resetEverything();

		window.location.replace(`${LOGIN_URL}?reset=${Date.now()}`);
	};

	return (
		<div className={`${styles.page}`}>
			<Image
				src={GeneralErrorImage}
				alt={'خطا'}
				width={188}
				height={210}
				className={`ml-24 mr-24 ${styles.page__image}`}
			/>
			<p
				className={`m-24 sm txt-text-gray ws-pre-wrap text-center ${styles.page__description}`}
			>
				برنامه به روزرسانی شده است. لطفا برای ادامه بر روی لینک زیر کلیک کنید.
			</p>
			<Button
				label={'ادامه'}
				onClick={onNavigateToLogin}
				disabled={isResetting}
				isLoading={isResetting}
				className={`mt-24 ${styles.page__button}`}
			/>
			<Button
				label={'تماس با پشتیبانی'}
				onClick={onCallToSupportTeam}
				variant={'outline'}
				className={`mt-16 ${styles.page__button}`}
			/>
		</div>
	);
};

export default ErrorPage;
